<template>
  <div tabindex="-1" class="modal-content">
    <header class="modal-header bg-primary text-white">
      <h5 class="modal-title">
        Information
      </h5>
    </header>
    <div class="modal-body">
      <h6 v-html-sanitize="messageTitle"></h6>
    </div>
    <footer class="modal-footer">
      <button @click="handleConfirm" type="button" class="btn btn-primary">
        Continue
      </button>
    </footer>
  </div>
</template>

<script>
import DialogMixin from "vuejs-dialog/dist/vuejs-dialog-mixin.min.js"; // Include mixin

export default {
  name: "DialogInfo",
  mixins: [DialogMixin],
  methods: {
    handleConfirm() {
      this.proceed(); // included in DialogMixin
    }
  },
  components: {}
};
</script>

<style scoped="">
.modal-content {
  margin: -15px;
  width: auto;
}
</style>
